import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductState } from 'types';

export const initialState: ProductState = {
  loading: false,
  productList: [],
  reset: false
};

const slice = createSlice({
  name: 'Products',
  initialState,
  reducers: {
    setProductList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.productList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setProductList, reset } = slice.actions;

export default slice.reducer;
